
const int = (error, val) => {
    let value = 1 * val;
    if (isNaN(value)) {
        throw new error()
    }
    return value;
};

const port = int;



module.exports = {
    int,
    port,
}